export function isMentorImageValid(imagePath) {
    const placeholderImagePath = "avatars/";
    return  imagePath!==undefined && imagePath !==null && !imagePath.includes(placeholderImagePath);
}